import { render, staticRenderFns } from "./ImportPolicy.vue?vue&type=template&id=14b79ce0&scoped=true"
import script from "./ImportPolicy.vue?vue&type=script&lang=js"
export * from "./ImportPolicy.vue?vue&type=script&lang=js"
import style0 from "./ImportPolicy.vue?vue&type=style&index=0&id=14b79ce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b79ce0",
  null
  
)

export default component.exports